/**
 * Error types for bulk indexing operations
 */

export interface BulkIndexingError extends Error {
  message: string;
  status?: number;
  error_code?: string;
  details?: string;
}

/**
 * Type guard to check if an error is a BulkIndexingError
 */
export function isBulkIndexingError(error: unknown): error is BulkIndexingError {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  const errorObj = error as Record<string, unknown>;
  return (
    'message' in errorObj &&
    typeof errorObj.message === 'string'
  );
}

/**
 * Extract error message from unknown error type
 */
export function getErrorMessage(error: unknown): string {
  if (isBulkIndexingError(error)) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'An unexpected error occurred';
}

/**
 * Extract error status code if available
 */
export function getErrorStatus(error: unknown): number | undefined {
  if (isBulkIndexingError(error) && error.status) {
    return error.status;
  }
  return undefined;
}

